import { render, staticRenderFns } from "./product-purchase-inbound-detail.vue?vue&type=template&id=0a6e1905&scoped=true"
import script from "./product-purchase-inbound-detail.vue?vue&type=script&lang=js"
export * from "./product-purchase-inbound-detail.vue?vue&type=script&lang=js"
import style0 from "./product-purchase-inbound-detail.vue?vue&type=style&index=0&id=0a6e1905&prod&lang=scss&scoped=true"
import style1 from "./product-purchase-inbound-detail.vue?vue&type=style&index=1&id=0a6e1905&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6e1905",
  null
  
)

export default component.exports